import { render, staticRenderFns } from "./FMDSection.vue?vue&type=template&id=225a3dd6&"
import script from "./FMDSection.vue?vue&type=script&lang=js&"
export * from "./FMDSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports